import { SLATE_PROMPT_TAGS, SLATE_TEXT_FORMATS, toggleSlateLink } from 'src/lib/slate';
import { isValidUrl } from 'src/lib/url';

const INLINES = [
  SLATE_TEXT_FORMATS.LINK,
  SLATE_TEXT_FORMATS.EXTERNAL_CHANNEL_TEXT,
  ...SLATE_PROMPT_TAGS,
];

export const withInlines = (editor) => {
  const { insertData, insertText, isInline } = editor;

  editor.isInline = (element) => {
    if (INLINES.includes(element.type)) {
      return true;
    }

    return isInline(element);
  };

  editor.insertText = (text) => {
    if (text && isValidUrl(text, { dontAddProtocol: true })) {
      toggleSlateLink(editor, text);
    } else {
      insertText(text);
    }
  };

  editor.insertData = (data) => {
    const text = data.getData('text/plain');

    if (text && isValidUrl(text, { dontAddProtocol: true })) {
      toggleSlateLink(editor, text);
    } else {
      insertData(data);
    }
  };

  return editor;
};
